import type { ReactNode } from 'react';

export const symbol_30fps: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M335-200H120q-16.67 0-28.33-11.74Q80-223.47 80-240.24 80-257 91.67-268.5 103.33-280 120-280h215v-160H123q-16.67 0-28.33-11.74Q83-463.47 83-480.24 83-497 94.67-508.5 106.33-520 123-520h212v-160H120q-16.67 0-28.33-11.74Q80-703.47 80-720.24 80-737 91.67-748.5 103.33-760 120-760h215q33.33 0 56.67 23.33Q415-713.33 415-680v131q0 29-19 50t-48 21q29 0 48 19t19 48v131q0 33.33-23.33 56.67Q368.33-200 335-200Zm247-80h218v-400H582v400Zm0 80q-33.33 0-56.67-23.33Q502-246.67 502-280v-400q0-33.33 23.33-56.67Q548.67-760 582-760h218q33.33 0 56.67 23.33Q880-713.33 880-680v400q0 33.33-23.33 56.67Q833.33-200 800-200H582Z"
		/>
	</svg>
);
